import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../services/user.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-my-password',
  templateUrl: './change-my-password.component.html',
  styleUrls: ['./change-my-password.component.scss']
})
export class ChangeMyPasswordComponent implements OnInit {

  public oldPassword : string = "";
  public password : string = "";
  public confirmPassword : string = "";
  public busy : boolean = false;
  public error : boolean = false;
  public errorMessage : string = "";

  constructor(
    public modal : NgbActiveModal,
    private userService : UserService,
    private translate : TranslateService
  ) { }

  ngOnInit() {
  }

  changePassword(){
    this.busy = true;
    this.error  = false;
      this.userService.changeMyPassword(this.oldPassword, this.password, this.confirmPassword).subscribe(
        result=>{          
          this.modal.close(this.translate.instant('bikeshop.modal.change_my_password.password_reset'));
          this.busy = false;
      },error=>{
        this.error  = true;
        this.errorMessage = this.translate.instant('bikeshop.modal.change_my_password.problem_resetting_password');
        this.busy = false;
      },()=>{
        
      });
  }

}
